<template>
    <span>
        <div class="vx-row">
            <div class="w-full vx-col">
                <vs-tabs id="skills-qualification-tabs" position="top" class="tabs-shadow-none">
                    <vs-tab label="Skill Qualification Categories">
                        <div class="tab-general">
                            <SkillQualificationCategories />
                        </div>
                    </vs-tab>
                    <vs-tab label="Staff Skills" v-if="$canAny(['view-staff-skills', 'create-edit-staff-skills'])">
                        <div class="tab-general">
                            <StaffSkillList />
                        </div>
                    </vs-tab>
                    <vs-tab label="Skill Qualifications" v-if="$canAny(['view-staff-qualifications', 'create-edit-staff-qualifications'])">
                        <div class="tab-general">
                            <SkillQualificationList />
                        </div>
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>
    </span>
</template>
<script>
import SkillQualificationCategories from '@/views/pages/settings/skills-and-qualifications/tabs/SkillQualificationCategories.vue'
import StaffSkillList from '@/views/pages/settings/skills-and-qualifications/tabs/StaffSkillList.vue'
import SkillQualificationList from '@/views/pages/settings/skills-and-qualifications/tabs/SkillQualificationList.vue'

export default {
    name: 'SkillsQualificationsHome',
    components: {
        SkillQualificationCategories,
        StaffSkillList,
        SkillQualificationList
    },
    data() {
        return {
            test: true
        }
    }

}
</script>

<style lang="scss">
#skills-qualification-tabs {
    width: 100%;

    .vs-tabs--ul {
        display: flex;
    }

    .vs-tabs-position-bottom .vs-tabs--ul,
    .vs-tabs-position-top .vs-tabs--ul {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        flex-wrap: wrap !important;
        justify-content: space-evenly;
    }

    .vs-tabs--li {
        flex-grow: 1 !important;
    }

    .line-vs-tabs {
        display: none;
    }

    .vs-tabs--li.activeChild {
        border-width: 0 0 2px 0;
        border-color: transparent;
        border-style: solid;
    }
}
</style>
